export const blockIconsTravelCottageNew = (
	<span className='material-symbols-outlined'>cottage</span>
);
